import React from "react";
import { convertUTCDateLocal } from "../../../../../../../utils/convertionFunc";

function CarePlanDailyMedicationTable({ data }) {
  const loggedUserObj = sessionStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  return (
    <>
      <div>
        <div
          className={`min-w-full ${data ? "w-max" : "w-full"
            } rounded-lg flex justify-center`}
        >
          <table className="w-full overflow-scroll relative">
            <thead className="border rounded-lg">
              <tr>
                <th>Medication Taken</th>
                <th>Medication Name</th>
                <th>Date & Time</th>
                <th>Entered By</th>
              </tr>
            </thead>
            <tbody className="text-center">
              {data?.map((item, idx) => (
                <React.Fragment key={item.key || idx}>
                  <tr className="border-b">
                    <td>{item.medicationTaken === "Y" ? "Yes" : "No"}</td>
                    <td>{item.drugName || "-"}</td>
                    <td>{convertUTCDateLocal(item.givenDate) || "-"}</td>
                    <td>
                      {item.enteredBy ||
                        `${loggedUser?.user?.salutation}${loggedUser?.user?.firstName} ${loggedUser?.user?.lastName}`}
                    </td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default CarePlanDailyMedicationTable;
